function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Modal from 'react-modal';
import './styles/prepaymentmodel.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { T, useTranslate } from 'shared/helper/translate';
import { price } from 'researcher/helpers/price';
import { getChinaLocalization } from 'shared/account/reducer';
import { syncPlagiarismPaymentStatus, eulaTermsAndConditionsload, eulaStatusCheck } from 'rubriq/actions';
import { searchPlagiarism } from 'researcher/plagiarism/actions';
import trackRubriqEvent from 'rubriq/helpers/trackRubriqEvent';
import PaddleBillingOverlayButton from '../../plan/PaddleBillingOverlayButton';
import { getAvailableNewPlans, getPaddlePrices, isPaddlePricesLoading } from '../../reducer';
import useNavigate from '../../hooks/useNavigate';
var RubriqPlagiarismPrePaymentModal = function RubriqPlagiarismPrePaymentModal(_ref) {
  var _newPlans$plagiarism$;
  var open = _ref.open,
    document = _ref.document,
    onClose = _ref.onClose;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var newPlans = useSelector(getAvailableNewPlans);
  var plagiarismPlans = newPlans.plagiarism[0] || [];
  var user = useSelector(function (_ref2) {
    var user = _ref2.user;
    return user;
  });
  var isChinaUser = useSelector(getChinaLocalization);
  var navigate = useNavigate();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    eulaAccepted = _useState2[0],
    setEulaAccepted = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    termLink = _useState4[0],
    setTermsLink = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isChecked = _useState6[0],
    setIsChecked = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showErrorMsg = _useState8[0],
    setShowErrorMsg = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isLoadingEula = _useState10[0],
    setIsLoadingEula = _useState10[1];
  var enablePaddleCountryPrice = true;
  var _useSelector = useSelector(function (state) {
      return state;
    }),
    siteLanguage = _useSelector.application.siteLanguage;
  var dispatch = useDispatch();
  var closePopup = function closePopup(result) {
    onClose(result);
  };
  var paddlePrices = useSelector(getPaddlePrices);
  var loadingPaddlePrices = useSelector(isPaddlePricesLoading);
  var getDisplayPrice = function getDisplayPrice(plan, fallbackPrice) {
    if (!enablePaddleCountryPrice || loadingPaddlePrices) {
      return price(user.currency, fallbackPrice, true, true);
    }
    var paddlePrice = paddlePrices[plan === null || plan === void 0 ? void 0 : plan.paddlePlanId];
    if (paddlePrice) {
      return paddlePrice.formatted;
    }
    return price(user.currency, fallbackPrice, true, true);
  };
  var onPlagiarismPaddleCheckoutClose = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(result) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (result) {
              if (document.fileIdentity) {
                dispatch(syncPlagiarismPaymentStatus(document.fileIdentity));
                navigate('/rubriq/plagiarism', {
                  replace: true
                });
              }
              dispatch(searchPlagiarism());
            }
            onClose(result);
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onPlagiarismPaddleCheckoutClose(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var iThenticateLanguage;
  switch (siteLanguage) {
    case 'br':
      iThenticateLanguage = 'pt-BR';
      break;
    case 'cn':
      iThenticateLanguage = 'zh-CN';
      break;
    case 'es':
      iThenticateLanguage = 'es-MX';
      break;
    case 'jp':
      iThenticateLanguage = 'ja-JP';
      break;
    default:
      iThenticateLanguage = 'en-US';
  }
  useEffect(function () {
    if (open && document !== null && document !== void 0 && document.fileIdentity) {
      var _plagiarismPlans$pric;
      trackRubriqEvent('Plagiarism Price Shown', {
        document_id: document.fileIdentity,
        price: (_plagiarismPlans$pric = plagiarismPlans === null || plagiarismPlans === void 0 ? void 0 : plagiarismPlans.price) !== null && _plagiarismPlans$pric !== void 0 ? _plagiarismPlans$pric : null,
        currency: user.currency,
        file_name: (document === null || document === void 0 ? void 0 : document.fileName) || null,
        email: user === null || user === void 0 ? void 0 : user.email,
        user_identity: user.identity,
        file_identity: document.fileIdentity
      });
    }
  }, [open]);
  useEffect(function () {
    var loadEULA = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return dispatch(eulaTermsAndConditionsload(iThenticateLanguage));
            case 2:
              response = _context2.sent;
              if (response.status === 'error') {
                // setTermsLink(false);
                setShowErrorMsg(true);
              } else {
                setTermsLink(response.url);
              }
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function loadEULA() {
        return _ref4.apply(this, arguments);
      };
    }();
    loadEULA();
  }, [iThenticateLanguage]);
  var handleCheckboxChange = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(e) {
      var checked, response;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            checked = e.target.checked;
            setIsChecked(checked);
            if (!checked) {
              _context3.next = 21;
              break;
            }
            trackRubriqEvent('Clicked I accept EULA', {
              document_id: document.fileIdentity,
              file_name: (document === null || document === void 0 ? void 0 : document.fileName) || null,
              email: user === null || user === void 0 ? void 0 : user.email,
              user_identity: user.identity,
              file_identity: document.fileIdentity
            });
            setIsLoadingEula(true);
            setEulaAccepted(false);
            _context3.prev = 6;
            _context3.next = 9;
            return dispatch(eulaStatusCheck(iThenticateLanguage, document.fileIdentity));
          case 9:
            response = _context3.sent;
            if (response.status === 'success') {
              setEulaAccepted(true);
            } else {
              setEulaAccepted(false);
            }
            _context3.next = 16;
            break;
          case 13:
            _context3.prev = 13;
            _context3.t0 = _context3["catch"](6);
            setEulaAccepted(false);
          case 16:
            _context3.prev = 16;
            setIsLoadingEula(false);
            return _context3.finish(16);
          case 19:
            _context3.next = 22;
            break;
          case 21:
            setEulaAccepted(false);
          case 22:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[6, 13, 16, 19]]);
    }));
    return function handleCheckboxChange(_x2) {
      return _ref5.apply(this, arguments);
    };
  }();
  useEffect(function () {
    if (open) {
      setEulaAccepted(false);
      setIsChecked(false);
      setIsLoadingEula(false);
    }
  }, [open]);
  var ChinaCheckoutButton = function ChinaCheckoutButton(_ref6) {
    var eulaAccepted = _ref6.eulaAccepted,
      isChecked = _ref6.isChecked,
      isLoadingEula = _ref6.isLoadingEula,
      fileIdentity = _ref6.fileIdentity;
    var navigate = useNavigate();
    var isDisabled = !eulaAccepted || !isChecked || isLoadingEula;
    var handleClick = function handleClick(e) {
      e.preventDefault();
      if (isDisabled) {
        return;
      }
      navigate('/rubriq/ithenticate/subscribe', {
        state: {
          fileIdentity: fileIdentity
        }
      });
    };
    return /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: handleClick,
      disabled: isDisabled,
      className: "btn btn-primary btn-squared me-3 ".concat(isDisabled ? 'disabled' : ''),
      "aria-disabled": isDisabled
    }, /*#__PURE__*/React.createElement(T, {
      source: "curie.checkout"
    }), ' ', isLoadingEula && /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: "fa-solid fa-spinner-scale",
      spin: true
    }));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, open && /*#__PURE__*/React.createElement("div", {
    className: "newModal"
  }, /*#__PURE__*/React.createElement(Modal, {
    appElement: window.document.querySelector('#researcher-app'),
    className: "rubriq-prepayment-modal",
    isOpen: true,
    overlayClassName: "rubriq-prepayment-modal-overlay"
  }, /*#__PURE__*/React.createElement("div", {
    className: "rubriq-prepayment-modal-header"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "rubriq-prepayment-modal-title"
  }, /*#__PURE__*/React.createElement(T, {
    source: "buy_ithenticate_report"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "rubriq-prepayment-modal-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "price-section"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "price"
  }, getDisplayPrice(newPlans.plagiarism[0], (_newPlans$plagiarism$ = newPlans.plagiarism[0]) === null || _newPlans$plagiarism$ === void 0 ? void 0 : _newPlans$plagiarism$.price)), /*#__PURE__*/React.createElement("p", {
    className: "price-subtitle"
  }, /*#__PURE__*/React.createElement(T, {
    source: "one_time_payment"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "purchase-details"
  }, /*#__PURE__*/React.createElement("h3", null, ' ', /*#__PURE__*/React.createElement(T, {
    source: "plagiarism_pricing_details_heading"
  })), /*#__PURE__*/React.createElement(T.md, {
    source: "plagiarism_pricing_details"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "confirmation-message"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, showErrorMsg ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", {
    style: {
      color: 'red'
    }
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.terms-issue"
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: isChecked,
    onChange: handleCheckboxChange,
    style: {
      fontSize: '16px'
    }
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      marginLeft: '10px'
    }
  }, ' ', /*#__PURE__*/React.createElement(T, {
    source: "eula-i-accept"
  })), /*#__PURE__*/React.createElement("a", {
    href: termLink,
    target: "_blank",
    rel: "noopener noreferrer",
    disabled: termLink
  }, /*#__PURE__*/React.createElement(T, {
    source: "eula-terms-and-conditions"
  })))), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: '16px',
      fontWeight: '400',
      marginTop: '25px'
    }
  }, /*#__PURE__*/React.createElement(T, {
    source: "proceed_to_payment_gateway"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "rubriq-prepayment-modal-footer"
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": t('cancel'),
    type: "button",
    className: "btn btn-secondary btn-squared",
    onClick: function onClick() {
      return closePopup(false);
    },
    style: {
      borderRadius: '8px',
      color: '#2D2F3C'
    }
  }, /*#__PURE__*/React.createElement(T, {
    source: "cancel"
  })), isChinaUser ? /*#__PURE__*/React.createElement(ChinaCheckoutButton, {
    eulaAccepted: eulaAccepted,
    isChecked: isChecked,
    isLoadingEula: isLoadingEula,
    fileIdentity: document.fileIdentity
  }) : /*#__PURE__*/React.createElement(PaddleBillingOverlayButton, {
    override: true,
    paddlePlanId: plagiarismPlans.paddlePlanId,
    onClose: onPlagiarismPaddleCheckoutClose,
    fileIdentity: document.fileIdentity,
    className: "btn btn-primary btn-squared me-3",
    disabled: !eulaAccepted || !isChecked || isLoadingEula
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.checkout-with-paddle"
  }), "\xA0", isLoadingEula && /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-spinner-scale",
    spin: true
  }))))));
};
export default RubriqPlagiarismPrePaymentModal;